import { z } from 'zod'
import type { CatalogApplication } from '#/domain/catalog/CatalogApplication'
import type { CatalogApplicationDto as CatalogApplicationDtoSpec } from '#/infrastructure/api/generated'
import type { Assert, SpecContract } from '#/infrastructure/api/SpecContract'

export const CatalogApplicationDtoSchema = z
  .object({
    Id: z.string(),
    DisplayName: z.string(),
  })
  .transform((raw): CatalogApplication => ({
    Id: raw.Id,
    DisplayName: raw.DisplayName,
  }))

export type CatalogApplicationResponseDto = z.input<typeof CatalogApplicationDtoSchema>
export type CatalogApplicationDtoSpecContract = Assert<
  SpecContract<CatalogApplicationResponseDto, CatalogApplicationDtoSpec>
>

export function toDomain(raw: CatalogApplicationResponseDto): CatalogApplication {
  return CatalogApplicationDtoSchema.parse(raw)
}

export function toDomainList(raw: CatalogApplicationResponseDto[]): CatalogApplication[] {
  return raw.map(toDomain)
}
